export default "__VITE_ASSET__DVlWxrB9__"